import { addressToString } from '@debbie/common/dist/index.js';
import { PropertyDataType, } from '@debbie/common/dist/properties/index.js';
import moment from 'moment';
import React from 'react';
import THEME from '../../theme.js';
import File from '../File/index.js';
import Money from '../Money.js';
const PropertyData = (props) => {
    if (!props.property) {
        return null;
    }
    const { type, data } = props.property;
    switch (type) {
        case PropertyDataType.singleLineText:
        case PropertyDataType.number:
        case PropertyDataType.multiLineText:
            return (React.createElement(React.Fragment, null, ['number', 'string'].includes(typeof data) ? data || '-' : '-'));
        case PropertyDataType.checkbox:
            return data ? React.createElement(React.Fragment, null, "\u2611") : React.createElement(React.Fragment, null, "\u25FB");
        case PropertyDataType.datePicker:
            return (React.createElement(React.Fragment, null, typeof data === 'string'
                ? moment(data).format(THEME.DATE_FORMAT_SHORT)
                : '-'));
        case PropertyDataType.address:
            return (React.createElement(React.Fragment, null, typeof data?.address === 'string' ? addressToString(data) : '-'));
        case PropertyDataType.file:
            return React.createElement(React.Fragment, null, data?.fileId ? React.createElement(File, { file: data }) : '-');
        case PropertyDataType.dropdown:
            return React.createElement(React.Fragment, null, data || '');
        case PropertyDataType.money:
            return (React.createElement(React.Fragment, null, data ? React.createElement(Money, { amount: data.amount, currency: data.currency }) : '-'));
        default:
            return null;
    }
};
export default PropertyData;
//# sourceMappingURL=PropertyData.js.map